import * as yup from 'yup';

export const initialValues = { motive: '', contactMe: true };

export const schema = yup.object().shape({
  motive: yup.string(),
  contactMe: yup.bool(),
});
